import { Component, OnInit, TemplateRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { UserService } from '../services/user.service';
import { UserDto, Role, vwUser, LookupDto } from '../models/User';
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { DataTableDirective } from 'angular-datatables';
import { ErrorHandlerService } from '../services/error-handler.service';
import { AlertService } from '../shared/services/alert.service';
import {RegionType, ZoneType, WoredaType, Department, ApplicantType, City, BranchOffice, SubCityType, FacilityType} from '../models/CommonModels';
import { CommonService } from '../shared/services/common.service';
import { combineLatest, Subscription } from 'rxjs';
import { ProductType } from "../models/CommonModels";
import * as Constants from "../models/Constants";
import { NgxSpinnerService } from 'ngx-spinner';
import {ChangePasswordComponent} from '../views/change-password/change-password.component';
import { AccountService } from '../services/account.service';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {

  @ViewChild(DataTableDirective, { static: true })
  datatableElement: DataTableDirective; // to get the datatable instance

  dtOptions: DataTables.Settings = {};
  users : vwUser[] = [];
  modalRef: BsModalRef;
  selectedUser : UserDto;
  roles :Role[] = [];
  constants: any = Constants;
  modalTitle = '';
  modalMessage = '';
  regionTypes : RegionType[];
  zoneTypes : ZoneType[];
  subCityTypes: SubCityType[];
  woredaTypes : WoredaType[];
  allZones  : ZoneType[];
  allWoredas : WoredaType[];
  subscriptions : Subscription[] = [];
  productTypes : ProductType[];
  showDepartments : boolean = false;
  showApplicantRole : boolean = false;
  departments : Department[] = [];
  selectedDepartment : Department;
  userErrorMessage:string= '';
  applicantRoles :  ApplicantType[];
  disableUsername : boolean = false;
  cities : City[];
  branchList : BranchOffice[];
  allBranches : BranchOffice[] = [];
  facilityTypes : FacilityType[] = [];
  selectedFacilityTypeId : number = null;
  showFacilityType : boolean = false;
  userRoleIDs: number[] = [];
  userDepartments : number[] = [];
  editUser: boolean = false;
  saveRoles: Role[] = [];
  deactivateUserId: number;
  showBranch : boolean = true;
  showErrors : boolean = false; // show validation errors when editing user
  showSubCity: boolean = false;

  constructor(private _userService: UserService, private modalService: BsModalService,
              private errorHandlerService: ErrorHandlerService, private alertService: AlertService,
              private commonService: CommonService, private changeDetection: ChangeDetectorRef, private spinner: NgxSpinnerService,
              private accountService: AccountService) {}

  ngOnInit() {
    this.dtOptions = this._userService.getDataTableOptions(this.users);
    this._userService.getRoles().subscribe(
      resp => {
        this.roles = resp;
        let index = this.roles.findIndex(r => r.roleCode === Constants.SUPER_ADMIN);
        this.roles.splice(index, 1);
      },
      error => {
        this.alertService.error('Network error, Please reload the page');
      }
    );
    this.getLocationTypes();
    this.getProductTypes();
    this.getApplicationTypes();
    this.getDepartments();
    this.getFacilityTypes();

  }

  getApplicationTypes(): void {
    this.commonService.getApplicationTypes().subscribe(applicationTypes => {
      this.applicantRoles = applicationTypes;
    });
  }

  showEditUserModal(id, template: TemplateRef < any > ) {
    this.setModalEvent();
    this.editUser = true;
    this.disableUsername = true;
    this.modalTitle = 'Update User';
    this.showErrors = true;
    this.selectedFacilityTypeId = null;
    this.branchList = [...this.allBranches];
    // let user = this.users.filter(user => user.id == id)[0];
    // we need a new object because we don't want chnages in the modal
    // to be reflected in the user list if the chnage is not saved
    this._userService.getUserAsAdmin(id).subscribe( user => {
      this.selectedUser = user;

      this.userRoleIDs = this.selectedUser.roles.map(role=> role.id);
      this.roleChange();
      this.userDepartments = this.selectedUser.departments.map(department=> department.id);/**Neccessary this line comes after role change */
      this.modalRef = this.modalService.show(template, {backdrop: 'static', keyboard: false, class: 'user-modal'});
      this.showSubCity = this.selectedUser.address.subCityId ? true: false;
      this.repopulateZoneAndWoredaList(this.selectedUser.address.regionId, this.selectedUser.address.zoneId, this.selectedUser.address.subCityId);
    });
  }
  showEditUserPasswordModal(id ) {
    const initialState = {
      title: 'Change Password',
      userID: id,
      oldPasswordRequired: false
    };
    this.modalRef = this.modalService.show(ChangePasswordComponent,{initialState, backdrop: 'static', class: 'modal-sm'});

    this.modalTitle = 'Change Password';

  }
  
  deactivateUser(){
   this._userService.deactivateUser(this.deactivateUserId).subscribe(
     resp =>{
      if(resp){
        this.alertService.success("User deactivated successfully");
        this.modalRef.hide();
        this.spinner.hide();
        this.reloadUserList();
      }else{
        this.alertService.success("Unable to deactivate user, please try again");
      }
    },
    error => {
      let errorMsg = this.errorHandlerService.handleApiError(error);
      this.userErrorMessage= errorMsg + " , please try again"
      setTimeout(() => {
        this.removeAlert();
       }, 15000);
      this.spinner.hide();


   });

  }

  activateUser(userId){
    this._userService.deactivateUser(userId).subscribe(
      resp =>{
       if(resp){
         this.alertService.success("User activated successfully");
         this.modalRef.hide();
         this.spinner.hide();
         this.reloadUserList();
       }else{
         this.alertService.success("Unable to activate user, please try again");
       }
     },
     error => {
       let errorMsg = this.errorHandlerService.handleApiError(error);
       this.userErrorMessage= errorMsg + " , please try again"
       setTimeout(() => {
         this.removeAlert();
        }, 15000);
       this.spinner.hide();


    });

  }
  updateProductTypes() {
    this.selectedUser.departments = [];
    this.userDepartments.forEach(dept=> this.selectedUser.departments.push(new LookupDto(dept, null, null)));
  }

  updateUser() {
    this.spinner.show();
    this.updateProductTypes();
    this.selectedUser['userDetails'] = null;
    this._userService.updateAsAdminUser(this.selectedUser).subscribe(
      resp => {
        if(resp){
          // to update the role name in the user list
          let index = this.users.findIndex(user => user.id === this.selectedUser.id);
          // this.users[index] = this.selectedUser; // update the user list
          this.users[index].firstName = this.selectedUser.firstName;
          this.users[index].lastName = this.selectedUser.lastName;
          this.users[index].username = this.selectedUser.username;
          this.users[index].roleName = this.saveRoles.map(role=>role.name).join(' , ');
          this.users[index].phone = this.selectedUser.phone;
          this.users[index].email = this.selectedUser.email;

          this.alertService.success('User Updated Successfully');
        }else{
          this.alertService.error('Unable to Update User');
        }
        this.modalRef.hide();
        this.spinner.hide();
      },
      error => {
        let errorMsg = this.errorHandlerService.handleApiError(error);
        this.alertService.error(errorMsg + ' , please try again');
        this.modalRef.hide();
        this.spinner.hide();
      }
    );
  }

  showCreateUserModal(template){
    this.setModalEvent();
    this.editUser = false;
    this.modalTitle = "Create New User";
    this.showErrors = false;

    this.selectedUser = new UserDto();
    this.userRoleIDs = [];
    this.userDepartments = [];
    this.selectedFacilityTypeId = null;
    this.showFacilityType = false;
    this.branchList = [...this.allBranches];

    this.modalRef = this.modalService.show(template, {backdrop: 'static', keyboard: false, class: 'user-modal'});
  }

  openAlertModal(template: TemplateRef<any>,userId) {
    this.modalRef = this.modalService.show(template,{backdrop: 'static', keyboard: false});
    this.deactivateUserId = userId;
  }

  createUser(){
    this.spinner.show();
    this.updateProductTypes();
    this._userService.createUser(this.selectedUser).subscribe(
      resp => {
        this.spinner.hide();
        if(resp){
          this.alertService.success("User created successfully, The password for the new user is " + resp.newPassword);
          this.modalRef.hide();
          this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.page('last').draw('page');
          });
        }else{
          this.alertService.success("Unable to save user, please try again");
        }
      },
      error => {
        let errorMsg = this.errorHandlerService.handleApiError(error);
        this.userErrorMessage= errorMsg + " , please try again"
        setTimeout(() => {
          this.removeAlert();
         }, 15000);
        this.spinner.hide();
      });
  }

  reloadUserList() {
    if (this.datatableElement.dtInstance) {
      this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.draw();
      });
    }
  }

  closeModal() {
    this.modalRef.hide();
  }
  removeAlert(){
    this.userErrorMessage =''
  }

  getProductTypes(): void{
    this.commonService.getProductTypes().subscribe(productTypes => this.productTypes = productTypes);
  }

  getDepartments(): void{
    this.commonService.getDepartments().subscribe(departments => this.departments = departments);
  }

  getFacilityTypes(): void {
    this.commonService.getFacilityTypes(true).subscribe(facilityTypes => {
      this.facilityTypes = facilityTypes;
    });
  }

  getLocationTypes(){
    this.commonService.getRegionTypes().subscribe(regionTypes => {
      this.regionTypes = regionTypes;
    });
    this.commonService.getCities().subscribe(cities => {
      this.cities = cities;
    });
    this.commonService.getBranchOffices().subscribe(branchList => {
      this.allBranches = branchList.map((branch) => {
        const cityName =  branch.city ? branch.city.name : '';
        branch.label = branch.name + ' (' + cityName + ')';
        return branch;
      });
      this.branchList = [...this.allBranches];
    });
  }

  roleChange(){
    let index;
    let roleCodes= [];
    this.selectedUser.roles = [];
    this.saveRoles = [];


    this.showDepartments = false;
    this.showApplicantRole = false;
    this.showFacilityType = false;
    this.selectedDepartment = null;

    const firstRoleCodeBatch = [Constants.INSPECTOR, Constants.CSO, Constants.DIRECTOR,
      Constants.INSPECTOR_TEAM_LEADER,Constants.CSO_TEAM_LEADER, Constants.ADMINISTRATOR];
    const secondRoleCodeBatch = [Constants.APPLICANT, Constants.PIP_APPLICANT, Constants.REGISTRANT];

    this.userRoleIDs.forEach(selectedRoleID=> {
      index = this.roles.findIndex(role=> role.id === selectedRoleID);
      if( index > -1){
        roleCodes.push(this.roles[index].roleCode)
        if(this.editUser) this.saveRoles.push(this.roles[index]);
        this.selectedUser.roles.push(new LookupDto(selectedRoleID, null, null));
      }
    });

    if(intersection(roleCodes, firstRoleCodeBatch).length>0){
      this.showDepartments = true;
      this.showBranch = true;
      this.showFacilityType = true;
    }

    if(intersection(roleCodes, secondRoleCodeBatch).length>0){
      this.showApplicantRole = true;
      this.showBranch = false;
      this.showFacilityType = false;
      this.selectedFacilityTypeId = null;
      this.branchList = [...this.allBranches];
    }

    function intersection(array1, array2){
      return array1.filter(elt=> array2.includes(elt));
    }
    this.userDepartments =  !this.showDepartments ? [] : this.userDepartments ;

    if(roleCodes.findIndex(r => r === Constants.AUDITOR) !== -1){
      this.showBranch = false;
      this.showFacilityType = false;
    }
  }

  updateHierarchyLists(adminBoundary:any, source:string){
    if (adminBoundary !== undefined) {
      switch (source) {

        case 'region':
          adminBoundary = <RegionType>adminBoundary;
          this.selectedUser.address.zoneId = null;
          this.selectedUser.address.woredaId = null;
          this.sortHierarchy(adminBoundary, source);
          this.woredaTypes = [];
          break;

        case 'zone':          
          adminBoundary = <ZoneType>adminBoundary;
          this.showSubCity = adminBoundary.isCity ? true: false;
          this.selectedUser.address.woredaId = null;
          this.selectedUser.address.subCityId = null;
          this.sortHierarchy(adminBoundary, source);
          break;
        case 'subCity':
          adminBoundary = <ZoneType>adminBoundary;
          this.selectedUser.address.woredaId = null;
          this.sortHierarchy(adminBoundary, source);
          break;
      }
    }
  }

  sortHierarchy = function (adminBoundary, source: string) {
    let selectedBoundaryID = adminBoundary !== null ? adminBoundary.id : -1;
    switch (source) {
      case 'region':
        this.commonService.getZoneTypesByRegion(selectedBoundaryID).subscribe(zoneTypes => {
          this.zoneTypes = zoneTypes;
        });
        break;
      case 'zone':
        if(adminBoundary.isCity){
          this.commonService.getSubCityTypesByZone(selectedBoundaryID).subscribe(subCityTypes => {
            this.subCityTypes = subCityTypes;
          });
        } else {
          this.commonService.getWoredaTypesByZone(selectedBoundaryID).subscribe(woredaTypes => {
            this.woredaTypes = woredaTypes;
          });
        }
        break;
      case 'subCity':
        this.commonService.getWoredaTypesBySubCity(selectedBoundaryID).subscribe(woredaTypes => {
          this.woredaTypes = woredaTypes;
        });
        break;
      default:
        break;
    }
  };

  unsubscribe() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions = [];
  }

  setModalEvent() {
    const _combine = combineLatest(
      this.modalService.onHide,
      this.modalService.onHidden
    ).subscribe(() => this.changeDetection.markForCheck());

    this.subscriptions.push(
      this.modalService.onHide.subscribe((reason: string) => {
        this.zoneTypes = this.allZones;
        this.woredaTypes = this.allWoredas;
        this.showDepartments = false;
        this.showApplicantRole = false;
        this.showFacilityType = false;
        this.selectedFacilityTypeId = null;
        this.branchList = [...this.allBranches];
        this.disableUsername = false;
      })
    );
    this.subscriptions.push(
      this.modalService.onHidden.subscribe((reason: string) => {
        this.unsubscribe();
      })
    );
    this.subscriptions.push(_combine);
  }

  isUserSuperAdmin() : boolean {
    return this.accountService.isUserSuperAdmin();
  }

  isCurrentRowInspector(user: vwUser) : boolean {  
    let roles = user.roleName;
    if(roles) {
      return roles.split(',').map(s => s.trim()).indexOf("Inspector") > -1;
    }
    
    return false;
  }

  showResetOdkPasswordModal(id ) {
    const initialState = {
      title: 'Reset ODK Password',
      userID: id,
      oldPasswordRequired: false,
      isOdkAccount: true
    };
    this.modalRef = this.modalService.show(ChangePasswordComponent,{initialState, backdrop: 'static', class: 'modal-sm'});
  }

  repopulateZoneAndWoredaList(regionID: number, zoneID: number, subCityID: number) {

    this.commonService.getZoneTypesByRegion(regionID).subscribe(zoneTypes => {
      this.zoneTypes = zoneTypes;
    });

    if(subCityID){
      this.commonService.getSubCityTypesByZone(zoneID).subscribe(subCityTypes => {
        this.subCityTypes = subCityTypes;
      });
      this.commonService.getWoredaTypesBySubCity(subCityID).subscribe(woredaTypes => {
        this.woredaTypes = woredaTypes;
      });
      this.showSubCity = true;
    } else {
      this.commonService.getWoredaTypesByZone(zoneID).subscribe(woredaTypes => {
        this.woredaTypes = woredaTypes;
      });
    }
  }

  onFacilityTypeChange(event: any) {
    const facilityTypeId = event && typeof event === 'object' ? event.id : (event || this.selectedFacilityTypeId);
    this.filterBranchesByFacilityType(facilityTypeId);
  }

  filterBranchesByFacilityType(facilityTypeOrId: any) {
    const facilityTypeId = facilityTypeOrId && typeof facilityTypeOrId === 'object'
      ? facilityTypeOrId.id
      : facilityTypeOrId;

    if (!facilityTypeId) {
      this.branchList = [...this.allBranches];
      return;
    }

    const facilityType = this.facilityTypes.find(f => f.id === facilityTypeId);
    if (!facilityType) {
      this.branchList = [...this.allBranches];
      return;
    }

    const code = (facilityType.facilityTypeCode || '').toUpperCase();
    const name = (facilityType.name || '').toUpperCase();

    if (code === 'MNFR' || name.includes('MANUFACTURER')) {
      // Manufacturers are regulated centrally by EFDA Head Office
      this.branchList = this.allBranches.filter(b => (b.name || '').toUpperCase().includes('EFDA'));
    } else if (code === 'EXPR' || name.includes('EXPORTER')) {
      // Exporters are regulated centrally by EFDA Head Office
      this.branchList = this.allBranches.filter(b => (b.name || '').toUpperCase().includes('EFDA'));
    } else if (code === 'IMPR' || name.includes('IMPORTER')) {
      // Importers operate through EFDA Head Office and Port Branch Offices (e.g. East Ethiopia / Dire Dawa)
      this.branchList = this.allBranches.filter(b => {
        const branchName = (b.name || '').toUpperCase();
        return branchName.includes('EFDA') || branchName.includes('EAST ETHIOPIA');
      });
    } else if (code === 'WSLR' || name.includes('WHOLESALER')) {
      // Wholesalers are licensed across all regional branch offices and EFDA
      this.branchList = [...this.allBranches];
    } else if (code === 'RTLR' || name.includes('RETAILER')) {
      // Retailers operate regionally
      this.branchList = this.allBranches.filter(b => !(b.name || '').toUpperCase().includes('EFDA'));
    } else {
      this.branchList = [...this.allBranches];
    }

    // Reset selected branch office if it is not in the filtered list
    if (this.selectedUser && this.selectedUser.branchOfficeId) {
      const exists = this.branchList.some(b => b.id === this.selectedUser.branchOfficeId);
      if (!exists) {
        this.selectedUser.branchOfficeId = null;
      }
    }
  }
}
